import { getResourceId } from "./getResourceId";
import { getResourcesNodes } from "./getResourcesNodes";

export function getAllResourcesIds(svg: SVGSVGElement): string[] {
  return getResourcesNodes(svg)?.map((x) => getResourceId(x) as string) || [];
}
